export type ProductFaq = {
	question: string
	answer: string
}

/**
 * Common FAQs displayed on all product pages.
 * These are designed to build trust with customers of a small,
 * local handmade patchwork shop.
 */
export const productFaqs: ProductFaq[] = [
	{
		question: "¿Cómo sé que este producto es realmente hecho a mano?",
		answer:
			"Cada pieza de Greta's Patchwork está confeccionada a mano por Greta en su taller. Debido al proceso artesanal, cada producto es único y puede presentar ligeras variaciones en el patrón o las costuras, lo que garantiza su autenticidad.",
	},
	{
		question: "¿Cuánto tarda en llegar mi pedido?",
		answer:
			"Los pedidos se preparan en 1-3 días laborables. El envío dentro de España peninsular suele tardar entre 2 y 5 días laborables. También realizamos envíos a otros países europeos, con un plazo estimado de 7 a 14 días laborables. Te enviaremos un correo con el número de seguimiento en cuanto tu pedido sea enviado.",
	},
	{
		question: "¿Puedo devolver o cambiar un producto?",
		answer:
			"Sí, aceptamos devoluciones y cambios en un plazo de 14 días desde la recepción del pedido, siempre que el producto esté en su estado original. Para artículos personalizados, por favor consulta nuestra política de devoluciones o contáctanos antes de realizar el pedido.",
	},
	{
		question: "¿Cómo debo cuidar y lavar mi producto de patchwork?",
		answer:
			"Recomendamos lavar a mano con agua fría y jabón suave, o usar el ciclo delicado de la lavadora dentro de una bolsa de lavado. Evita la secadora y tiende en plano para secar. Esto mantendrá los colores vivos y las costuras en perfecto estado durante años.",
	},
	{
		question: "¿Es seguro comprar en esta tienda online?",
		answer:
			"Totalmente. Utilizamos pasarelas de pago seguras (Stripe) que cifran todos tus datos. Nunca almacenamos la información de tu tarjeta. Además, cumplimos con la normativa europea de protección de datos (RGPD).",
	},
	{
		question: "¿Puedo solicitar un diseño personalizado o un tamaño especial?",
		answer:
			"¡Por supuesto! Nos encanta crear piezas únicas. Contáctanos a través de nuestra página de contacto con tu idea, las medidas deseadas y los colores que prefieras, y te enviaremos un presupuesto sin compromiso.",
	},
	{
		question: "¿Qué materiales utilizáis en vuestros productos?",
		answer:
			"Trabajamos con telas 100% algodón de alta calidad, seleccionadas especialmente para patchwork. Utilizamos guatas de primera calidad e hilos resistentes que garantizan la durabilidad de cada pieza.",
	},
]
